import { createContext, useContext, useEffect, useMemo, useState } from "react";
import strings, { LANGS } from "./strings";

const STORAGE_KEY = "lang";

const initialLang = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (LANGS.includes(saved)) return saved;
  } catch (e) {
    // storage unavailable — fall through to the browser language
  }
  return (navigator.language || "en").toLowerCase().startsWith("tr") ? "tr" : "en";
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);

  useEffect(() => {
    // lang on <html> also makes CSS uppercase follow Turkish rules (i → İ)
    document.documentElement.lang = lang;
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      // ignore
    }
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: strings[lang] }), [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

const useLang = () => useContext(LanguageContext);

export default useLang;
